import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "./components/RouteGuards";
import { LoginPage } from "./features/auth/LoginPage";
import { ResetPasswordPage } from "./features/auth/ResetPasswordPage";
import { AdminLayout } from "./features/admin/AdminLayout";
import { DashboardPage } from "./features/admin/DashboardPage";
import { GalleryPage } from "./features/admin/GalleryPage";
import { SnapshotGalleryPage } from "./features/admin/SnapshotGalleryPage";
import { SiteBuilderPage } from "./features/admin/SiteBuilderPage";
import { PrintQueuePage } from "./features/admin/settings/PrintQueuePage";
import { TeamPage } from "./features/admin/settings/TeamPage";
import { OrganizationPage } from "./features/admin/settings/OrganizationPage";
import { RevenuePage } from "./features/admin/settings/RevenuePage";
import { BoothApp } from "./features/booth/BoothApp";
import { PaymentReturnPage } from "./features/booth/PaymentReturnPage";
import { SharePage } from "./features/booth/SharePage";
import { NotFoundPage } from "./features/booth/NotFoundPage";

/**
 * One app, two audiences.
 *
 *   /admin/*   the console — operators create and configure events
 *   /s/:token  a guest's share link, the target of the result-screen QR
 *   /pay/:ref  where a guest's phone lands after paying for a snapshot
 *   /:slug     the booth for a published event, which is the link the console
 *              hands out per event (/nigus-malt, /habesha, ...)
 *
 * The booth route is last so it can be a bare slug without shadowing anything.
 */
export function App() {
  return (
    <Routes>
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin/reset-password" element={<ResetPasswordPage />} />

      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="snapshot-gallery" element={<SnapshotGalleryPage />} />
        <Route path="revenue" element={<RevenuePage />} />
        <Route path="print-queue" element={<PrintQueuePage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="organization" element={<OrganizationPage />} />
      </Route>

      {/* Full-bleed: the Site Builder owns the whole viewport for its live preview. */}
      <Route
        path="/admin/events/:eventId/builder"
        element={
          <RequireAuth>
            <SiteBuilderPage />
          </RequireAuth>
        }
      />

      <Route path="/s/:token" element={<SharePage />} />
      <Route path="/pay/:reference" element={<PaymentReturnPage />} />
      <Route path="/:slug/*" element={<BoothApp />} />
      <Route path="/" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
